import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_CONTACT_TRANSACTIONS_REQUEST = "API_CONTACT_TRANSACTIONS_REQUEST";
export const API_CONTACT_TRANSACTIONS_SUCCESS = "API_CONTACT_TRANSACTIONS_SUCCESS";
export const API_CONTACT_TRANSACTIONS_FAILURE = "API_CONTACT_TRANSACTIONS_FAILURE";

export const api_contact_transactions_request = (options) => {
	return {
		type: API_CONTACT_TRANSACTIONS_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_contact_transactions_success = (data) => {
	return {
		type: API_CONTACT_TRANSACTIONS_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_contact_transactions_failure = (error) => {
	return {
		type: API_CONTACT_TRANSACTIONS_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Contact.apiContactTransactions
	Liefert alle, für den TR_TYPE und eingelogten User verfügbaren Transactions
			:param TR_TYPE:
			:return:
*/
export const apiContactTransactions = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_contact_transactions_request(options));
			const url=getAPIUrl([
				{"url": "/api/contact/transactions/${options.TR_TYPE}", "parameters": ["TR_TYPE"]},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_contact_transactions_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_contact_transactions_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
